<template>
  <div class="h-full">
    <div class="relative z-0 flex flex-1 h-full overflow-hidden">
      <main
        class="relative z-0 flex-1 h-full overflow-y-auto bg-red-500 focus:outline-none xl:order-last"
        tabindex="0"
      >

        <AppGallery v-show="showGallery" v-bind:gallery="gallery" v-on:close="onCloseGallery" />

        <div class="absolute inset-0">
          <div class="relative h-full bg-gray-900">

            <AppSplash v-if="showSplash"
              v-on:setup="setupFurioos"
              v-bind:progress="playerLoadingProgress"
              v-bind:player-ready-for-setup="playerReadyForSetup" 
              v-bind:player-has-timed-out="playerHasTimedOut"/>
        
            <div
              id="furioos_container"
              ref="furioosContainer"
              class="w-full h-full"
              v-show="!showSplash"
              :style="furioosIframeContainerStyle"
            ></div>
            <div v-if="forceShowUI" 
              :style="furioosIframeContainerStyle" class="w-full h-full bg-red-500 border-2 border-white">
              
              <div class="flex justify-around h-full bg-blue-200">
                <div class="flex items-center self-center justify-center w-16 h-16 m-2 text-2xl font-extrabold text-white bg-blue-500 rounded-md">1</div>
                <div class="flex items-center self-center justify-center w-16 h-16 m-2 text-2xl font-extrabold text-white bg-blue-500 rounded-md">2</div>
                <div class="flex items-center self-center justify-center w-16 h-16 m-2 text-2xl font-extrabold text-white bg-blue-500 rounded-md">3</div>
              </div>

            </div>
          </div>
        </div>
      </main>
    </div>

    <AppControls
      v-if="showControls"
      v-on:change="handleChange"
      v-on:capture="handleCapture"
      v-on:view-gallery="viewGallery"
      v-bind:state="state"
      v-bind:gallery="gallery"/>

  </div>
</template>

<script>
const AppControls = () => import("@/components/app/AppControls");
const AppGallery = () => import("@/components/app/AppGallery");
const AppSplash = () => import("@/components/app/AppSplash");
import mixin from "./furioosMixin.js";

export default {
  name: "app-container",
  mixins: [mixin],

  data() {
    return {
      showDebug: true,
      forceShowUI: false,
      showGallery: false,
      addDemoGalleryItemsOnMount: false,

      state: {
        look: 'look_1',
        video: 'video_1',
        scene: 'scene_1',
        light: 'light_1', 
        prop1: 0,
        prop2: 0, 
        cameraZoom: 3, 
        cameraFocus: true, 
        effectsStyle: 3
      }
    };
  },

  components: {
    AppControls,
    AppGallery,
    AppSplash
  },

  mounted () {
    if(this.addDemoGalleryItemsOnMount) this.addDemoGalleryItems()
  },

  watch: {
    'state.look': function(newVal) {
      let sceneVal = this.state.scene 
      let effectsVal = this.state.effectsStyle

      switch(newVal) {
        case 'look_1': 
          sceneVal = 'scene_1'
          effectsVal = 0
          break
        case 'look_2': 
          sceneVal = 'scene_6'
          effectsVal = 1
          break
        case 'look_3': 
          sceneVal = 'scene_3'
          effectsVal = 2
          break
        case 'look_4': 
          sceneVal = 'scene_4'
          effectsVal = 3
          break
        case 'look_5':
          sceneVal = 'scene_2'
          effectsVal = 4
          break
        case 'look_6':
          sceneVal = 'scene_5'
          effectsVal = 5
          break
      }

      this.state.scene = sceneVal 
      this.state.effectsStyle = effectsVal
    },

    'state.scene': function(newVal) {
        this.state.light = 'light_1'
        this.state.prop1 = 0
        this.state.prop2 = 0
    }
  },

  /*Preset 1:
scene 1, style 1
Preset 2:
scene 6, style 2
Preset 3:
scene 3, style 3
Preset 4:
scene 4, style 4
Preset 5:
scene 2, style 5
Preset 6:
scene 5, style 6*/

  methods: {

    addDemoGalleryItems () {
      
      this.gallery.push({
          id: 'demo', 
          uri: 'https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=512&q=80',
          thumbnail: 'https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=50&q=80'
        })

      this.gallery.push({
          id: 'demo2', 
          uri: 'https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=512&q=80',
          thumbnail: 'https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=50&q=80'
        })

      this.gallery.push({
          id: 'demo3', 
          uri: 'https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=512&q=80',
          thumbnail: 'https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=50&q=80'
        })
    },

    onCloseGallery () {
      this.showGallery = false 
    },

    viewGallery () {
      this.showGallery = true
    },
    
    handleChange (e) {
      // todo - send this down to the furioos player via an sdk message 
      this.sendSDKUpdateStateMessage(e)
      this.state[e.key] = e.value
    },

    handleCapture (e) {
      this.sendSDKRequestCaptureMessage(e)
    }
  },

  computed: {

    showControls () {
      return (this.playerLaunched || this.forceShowUI) && !this.showGallery 
    },

    showSplash () {
      return !this.playerLaunched && !this.forceShowUI
    }
  }
};
</script>
